import { Dispatch } from '@reduxjs/toolkit';
import { AppState } from '../store';
// eslint-disable-next-line max-len
import { IAccommodationBlockingPayload } from '../../components/shared/accommodation-blocking-form/accommodation-blocking-payload';
import { IAccommodationBlocking } from '../actions/sales-configuration';
import { parseViolationMessages } from './parse-violation-messages';

export type SaveAccommodationBlockingResult =
  | { status: 'saved'; blocking: IAccommodationBlocking }
  | { status: 'rejected'; messages: string[] }
  | { status: 'failed' };

export { GENERIC_FAILURE_MESSAGE } from './parse-violation-messages';

export function postAccommodationBlocking(payload: IAccommodationBlockingPayload): ReduxAction {
  return async (dispatch: Dispatch, getState: () => AppState): Promise<SaveAccommodationBlockingResult> => {
    const {
      general: { appConfiguration, accessToken },
    } = getState();

    try {
      const response = await fetch(`${appConfiguration.VITE_API_SALES_CONFIGURATION}/api/AccommodationBlocking`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          Authorization: `Bearer ${accessToken}`,
        },
        body: JSON.stringify(payload),
      });

      if (response.ok) {
        const blocking = (await response.json()) as IAccommodationBlocking;
        return { status: 'saved', blocking };
      }

      if (response.status === 400) {
        const messages = await parseViolationMessages(response);
        return { status: 'rejected', messages };
      }

      console.error(`Unexpected response saving Accommodation Blocking: ${response.status}`);
      return { status: 'failed' };
    } catch (error) {
      console.error(error);
      return { status: 'failed' };
    }
  };
}
